import UserInputResult from "./UserInputResult";
import { percentagePointsReached } from './calculatePoints'

export default class MilitaryReactionTestValidator
{
    static isAnswerCorrect(answer)
    {
        const question = answer.question()
        const userInput = answer.userInput()[0]
        const userInputResult = new UserInputResult()

        userInputResult.resetResultStructureWith(userInput ? userInput.value: null)

        return percentagePointsReached(userInputResult, question) >= 75
    }
}

